/*
 * View more has structure like this:
 * <div class="view-more-wrapper" [data-initial-height-percent="XX"]>
 *   <div class="view-more-content">The content</div>
 *   <div class="view-more-button">The button</div>
 * </div> 
 * If attribute data-initial-height-percent is set, that's folded height in vw
 * units.
 * Els, if inside content there is a ".view-more-limit", it is taken as
 * reference to limit visible part up to, but not including, that element. If
 * there are more than one, onlly the first has effect.
 */

document.addEventListener('DOMContentLoaded', function ()
{
    const wrapperEls = document.querySelectorAll('.view-more-wrapper');
    for (const wrapperEl of wrapperEls)
    {
        init(wrapperEl);
    }
});

function init (wrapperEl)
{
    /* Elements */
    const contentWrapperEl = wrapperEl.querySelector('.view-more-content')
    const moreButtonEl = wrapperEl.querySelector('.view-more-button')
    const moreContentEl = contentWrapperEl.querySelector('.view-more-limit')

    /* Parameters */
    const initialHeightPercent = wrapperEl.dataset.initialHeightPercent;

    let totalHeight
    let foldedHeight

    if (initialHeightPercent || moreContentEl)
    {
        contentWrapperEl.style.overflowY = 'hidden'
        moreButtonEl.addEventListener('click', onMoreButtonClick)
        window.addEventListener('resize', updateTableHeight)
        updateTableHeight()
        setTimeout(() => {
            updateTableHeight()
        }, 100)
    }

    function onMoreButtonClick ()
    {
        if (contentWrapperEl.classList.contains('unfolded'))
        {
            contentWrapperEl.classList.remove('unfolded')
            moreButtonEl.classList.remove('unfolded')
        }
        else
        {
            contentWrapperEl.classList.add('unfolded')
            moreButtonEl.classList.add('unfolded')
        }
        updateTableHeightChange()
    }

    function updateTableHeight()
    {
        contentWrapperEl.classList.remove('aniations-activated')
        contentWrapperEl.style.height = 'auto'
        totalHeight = contentWrapperEl.offsetHeight + 3
        if (initialHeightPercent)
        {
            foldedHeight = Math.round(window.innerHeight * initialHeightPercent / 100)
        }
        else if (moreContentEl)
        {
            foldedHeight = moreContentEl.getBoundingClientRect().top - contentWrapperEl.getBoundingClientRect().top
        }
        else
        {
            foldedHeight = undefined
        }
        if (foldedHeight !== undefined && foldedHeight < totalHeight)
        {
            updateTableHeightChange()
            contentWrapperEl.classList.add('animations-activated')
            moreButtonEl.classList.add('activated')
        }
        else
        {
            moreButtonEl.classList.remove('activated')
        }
    }

    function updateTableHeightChange()
    {
        if (contentWrapperEl.classList.contains('unfolded'))
        {
            contentWrapperEl.style.height = totalHeight+'px'
        }
        else
        {
            contentWrapperEl.style.height = foldedHeight+'px'
        }
    }

}
